<template>
    <div class="custom-navbar">
        <div class="nav-content">
            <ul class="nav">
                <li class="logo-item">
                    <a href="#" @click.prevent="selectNavItem('homepage')" style="padding: 30px 0px;">
                        <div class="icon">
                            <div class="imageBox">
                                <div class="logo-placeholder">雪</div>
                            </div>
                        </div>
                        <div class="text">雪音时光收藏馆</div>
                    </a>
                </li>

                <li v-for="(item, index) in navItems" :key="index" :class="{ active: currentNavItem === item.id }">
                    <a href="#" @click.prevent="selectNavItem(item.id)">
                        <div class="text no-underline">{{ item.text }}</div>
                    </a>
                </li>

                <li class="nav-spacer"></li>
            </ul>
        </div>

        <div class="music-player-wrapper">
            <MusicPlayer />
        </div>
    </div>
</template>

<script>
import { navItems } from '../data/navItems.js'
import MusicPlayer from './MusicPlayer.vue'

export default {
    name: 'CustomNavbar',
    components: {
        MusicPlayer
    },
    props: {
        currentNavItem: {
            type: String,
            default: 'homepage'
        },
        isPlaying: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            navItems
        }
    },
    methods: {
        selectNavItem(itemId) {
            this.$emit('nav-click', itemId)
        }
    }
}
</script>

<style scoped>
* {
    box-sizing: border-box;
    list-style: none;
    text-decoration: none;
}

.custom-navbar {
    width: 100%;
    height: 100%;
    background: #000000;
    z-index: 9999;
    padding-left: 10px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    overflow: hidden;
}

.nav-content {
    flex: 1;
    padding-bottom: 10px;
    overflow: auto;
    touch-action: pan-y pan-x;
    -webkit-overflow-scrolling: touch;
    height: calc(100% - 80px);
}

.music-player-wrapper {
    width: 100%;
    background: #000;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.imageBox {
    position: relative;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    overflow: hidden;
    background: #ffa117;
    display: flex;
    justify-content: center;
    align-items: center;
}

.custom-navbar .nav {
    position: relative;
    height: 90%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin: 0;
    padding: 0;
}

.custom-navbar .nav li {
    position: relative;
    padding-left: 30px;
}

.nav-spacer {
    flex-grow: 1;
}

.active {
    background: #E3E8F4;
    border-top-left-radius: 50px;
    border-bottom-left-radius: 50px;
}

.active::before {
    content: "";
    position: absolute;
    top: -30px;
    right: 0;
    width: 30px;
    height: 30px;
    border-bottom-right-radius: 25px;
    box-shadow: 5px 5px 0 5px #E3E8F4;
    background: transparent;
}

.active::after {
    content: "";
    position: absolute;
    bottom: -30px;
    right: 0;
    width: 30px;
    height: 30px;
    border-top-right-radius: 25px;
    box-shadow: 5px -5px 0 5px #E3E8F4;
    background: transparent;
}

.custom-navbar .nav li a {
    position: relative;
    display: flex;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    width: 100%;
}

.icon {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 60px;
    padding-left: 10px;
    height: 70px;
    color: rgb(255, 255, 255);
    font-size: 30px;
    transition: 0.5s;
}

.icon i {
    z-index: 999;
}

.text {
    position: relative;
    height: 70px;
    display: flex;
    align-items: center;
    font-size: 20px;
    color: #ffad32c1;
    padding-left: 15px;
    letter-spacing: 2px;
    transition: 0.5s;
}

.no-underline {
    text-decoration: none !important;
}

.custom-navbar .nav li:hover a .icon,
.custom-navbar .nav li:hover a .text {
    color: #ffa117;
}

.active a .icon::before {
    content: "";
    position: absolute;
    inset: 5px;
    width: 60px;
    background: #000000;
    border-radius: 50%;
    transition: 0.5s;
    border: 7px solid #ffa117;
    box-sizing: border-box;
}

.active a .icon,
.active a .text {
    color: #ffa117 !important;
}

.nav-content::-webkit-scrollbar {
    width: 4px;
}

.nav-content::-webkit-scrollbar-thumb {
    background: #ffad32;
    border-radius: 2px;
}

.nav-content::-webkit-scrollbar-track {
    background: #333;
}

@media (max-width: 768px) {
    .text {
        font-size: 16px;
        padding-left: 10px;
        height: 60px;
    }

    .icon {
        min-width: 40px;
        height: 60px;
        font-size: 24px;
    }

    .custom-navbar .nav li {
        padding-left: 15px;
    }

    .active::before {
        top: -20px;
        width: 20px;
        height: 20px;
        box-shadow: 4px 4px 0 4px #E3E8F4;
    }

    .active::after {
        bottom: -20px;
        width: 20px;
        height: 20px;
        box-shadow: 4px -4px 0 4px #E3E8F4;
    }
}

@media (max-width: 480px) {
    .text {
        font-size: 14px;
        padding-left: 8px;
    }

    .icon {
        min-width: 30px;
        font-size: 20px;
    }
}
</style>